import React from 'react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white py-16 border-t border-gray-800" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-34">
        <div className="text-center md:text-left" data-id="element-35">
          <h3 className="text-3xl font-serif mb-2" data-id="element-36">Modern Fix</h3>
          <p className="text-gray-400 text-sm tracking-wide" data-id="element-37">
            Residential Remodeling – Los Angeles
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12 text-sm text-gray-300" data-id="element-38">
          <span className="text-gray-300" data-id="element-39">ModernFix@protonmail.com</span>
          <span className="hidden md:inline text-gray-600" data-id="element-40">|</span>
          <a href="tel:7474776633" className="hover:text-white transition-colors" data-id="element-41">
            747-477-6633
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-8 border-t border-gray-800/50 text-center md:text-left text-xs text-gray-500" data-id="element-42">
        &copy; {new Date().getFullYear()} Modern Fix. All rights reserved.
      </div>
    </footer>;
}